<div *ngIf="performanceModel?.accountProfile">
    <table style=  "width: 100%">
        <tr class="historical-volatility-header" aria-label="Historical volitility measure">
            <th scope="col" style="text-align:left">Trading Cutoffs</th>
            <th scope="col"></th>
            </tr>
            <tr class="historical-volatility">
                <td scope="col" style="text-align:left">Deadline for Purchases</td>
                <td scope="col">{{performanceModel?.accountProfile?.deadlineforPurchasesTradingCutoffs | DashIfEmpty }}</td>
               
            </tr>
            <tr class="historical-volatility">
                <td scope="col" style="text-align:left">Deadline for Redemptions</td>
                <td scope="col">{{performanceModel?.accountProfile?.deadlineforRedemptionsCutoffs| DashIfEmpty}}</td>
            </tr>

            <tr class="historical-volatility">
                <td scope="col" style="text-align:left">Deadline for Exchanges</td>
                <td scope="col">{{performanceModel?.accountProfile?.deadlineforExchangesCutoffs| DashIfEmpty}}</td>
            </tr>
            </table>
</div>
<div *ngIf="!performanceModel?.accountProfile">
    <p class="rps-paragraph-one">Trading Cutoffs</p>
    <p class="rps-paragraph-one">This information is temporarily unavailable.</p>
</div>